import React, {Component} from 'react'
import {connect} from 'react-redux'
import FJCommonModal from '../../../common/component/modal/FJCommonModal';
import FJTextEditorModal from '../view/FJTextEditorModal';
import {FJModalAction, FJToolbarAction} from "../../../redux/action/FJRoot.action";
import FJMediaAction from "../../../redux/action/FJMedia.action";

class FJTextEditorModalContainer extends Component {

  constructor(props) {
    super(props);
    this._textEditor = React.createRef();
  }

  /**
   * @description 初始化内容
   * @private
   */
  _initTextEdit = () => {
    this._textEditor.current.callback();
  };

  render() {
    let {
      visible,
      textLength,
      textData,
      onCancel,
      focusIndex,
      textContentChangeAction,
      updateDragFileModeStateAction
    } = this.props;

    return (
      <FJCommonModal visible={visible}
                     hasOuterCloseBtn
                     onCancel={onCancel}
                     width='600px'
                     onHidden={this._initTextEdit}
                     onShow={this._initTextEdit}
                     updateDragFileModeStateAction={updateDragFileModeStateAction}

      >
        <FJTextEditorModal ref={this._textEditor}
                           visible={visible}
                           maxContent={textLength}
                           focusIndex={focusIndex}
                           onCancel={onCancel}
                           textContentChangeAction={textContentChangeAction}
                           textData={textData}
        />
      </FJCommonModal>
    )
  }
}

const mapStateToProps = function (state) {
  return {
    visible: state.modal.isShowTextEditorModal,
    textData: state.toolbarText.textData,
    textLength: state.toolbarText.textLength,
    focusIndex: state.toolbarText.focusIndex,
  }
};

const mapDispatchToProps = function (dispatch) {
  return {
    onCancel: function () {
      dispatch(FJModalAction.setIsShowTextEditorModalAction(false))
    },
    textContentChangeAction: function (textData) {
      dispatch(FJModalAction.setIsShowTextEditorModalAction(false));
      dispatch(FJToolbarAction.textContentChangeAction(textData));
    },
    updateDragFileModeStateAction: function (visible) {
      dispatch(FJMediaAction.updateDragFileModeStateAction(visible))
    }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(FJTextEditorModalContainer);
